/*
 * @Version: 1.0
 * @Autor: wenruihuan
 * @Date: 2022-04-03 18:29:47
 * @LastEditors: myname
 * @LastEditTime: 2022-04-04 03:21:54
 */
import commonSwitch from './common-switch.vue'
// 这里是重点
const cmSwitch = {
    install: function(Vue){
        Vue.component('commonSwitch', commonSwitch)
    }
}

// 导出组件
export default cmSwitch